import { Props } from "../interfaces/layout";
import LayoutUnified from "./LayoutUnified";
import AdminTutorial from "../pages/admin/components/AdminTutorial";

export const LayoutUserCafe = ({ children }: Props) => {
  return <LayoutUnified>{children}</LayoutUnified>;
};

export const LayoutAdminCafe = ({ children }: Props) => {
  return (
    <LayoutUnified>
      <AdminTutorial />
      {children}
    </LayoutUnified>
  );
};
